import { CsvExportColumn } from "./csvExport"
import { AgencyAgentExportRow } from "./agencyExportTypes"

/**
 * Agency CSV column layout (one row per agent).
 * Edit this list to add, remove, or reorder export columns without touching download logic.
 */
export const AGENCY_CSV_COLUMNS: CsvExportColumn<AgencyAgentExportRow>[] = [
  {
    key: "agency",
    header: "Agency",
    getValue: (row) => row.agency,
  },
  {
    key: "office",
    header: "Office",
    getValue: (row) => row.office,
  },
  {
    key: "agent",
    header: "Agent",
    getValue: (row) => row.agent,
  },
  {
    key: "phone",
    header: "Phone",
    getValue: (row) => row.phone,
  },
  {
    key: "email",
    header: "Email",
    getValue: (row) => row.email,
  },
  {
    key: "status",
    header: "Status",
    getValue: (row) => row.status,
  },
]
